module.exports = __webpack_public_path__ + "static/hover_bg_materica-c037068e0a10e4d3cc62ce8d5fffa6c1.jpg";